import React, { useState } from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { STORE } from "@/lib/store";

export default function Contact() {
  const { t } = useI18n();
  const [form, setForm] = useState({ name: "", email: "", phone: "", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/leads", form);
      setSent(true);
      toast.success(t("contact.sent"));
      setForm({ name: "", email: "", phone: "", message: "" });
    } catch (err) {
      toast.error("Erreur", { description: err.response?.data?.detail || err.message });
    }
  };

  return (
    <div className="mx-auto max-w-7xl px-4 py-12">
      <h1 className="font-heading text-4xl sm:text-5xl font-extrabold tracking-tight">{t("contact.title")}</h1>
      <p className="text-gray-500 mt-2 mb-12">{t("contact.subtitle")}</p>
      <div className="grid lg:grid-cols-2 gap-12">
        <div className="space-y-6">
          <div className="flex gap-4 border border-gray-200 bg-white p-6"><MapPin className="text-brand-red shrink-0" /><div><h4 className="font-semibold">{t("contact.title")}</h4><p className="text-gray-600 text-sm mt-1">{STORE.address}<br />{STORE.city}</p></div></div>
          <div className="flex gap-4 border border-gray-200 bg-white p-6"><Phone className="text-brand-red shrink-0" /><div><h4 className="font-semibold">{t("checkout.phone")}</h4><a href={`tel:${STORE.phoneRaw}`} className="text-gray-600 text-sm mt-1 block hover:text-brand-red">{STORE.phone}</a></div></div>
          <div className="flex gap-4 border border-gray-200 bg-white p-6"><Mail className="text-brand-red shrink-0" /><div><h4 className="font-semibold">{t("contact.email")}</h4><a href={`mailto:${STORE.email}`} className="text-gray-600 text-sm mt-1 block hover:text-brand-red">{STORE.email}</a></div></div>
          <div className="flex gap-4 border border-gray-200 bg-white p-6"><Clock className="text-brand-red shrink-0" /><div><h4 className="font-semibold">{STORE.hours}</h4></div></div>
          <div className="border border-gray-200 overflow-hidden h-64">
            <iframe title="carte" width="100%" height="100%" style={{ border: 0 }} loading="lazy"
              src="https://maps.google.com/maps?q=4100%20rue%20Jarry%20E%20Montreal&t=&z=14&ie=UTF8&iwloc=&output=embed" />
          </div>
        </div>
        <form onSubmit={submit} className="border border-gray-200 bg-white p-8 space-y-5 h-fit" data-testid="contact-form">
          <div><label className="block text-sm font-medium mb-1">{t("contact.name")} *</label><input value={form.name} onChange={set("name")} required className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="contact-name" /></div>
          <div><label className="block text-sm font-medium mb-1">{t("contact.email")} *</label><input type="email" value={form.email} onChange={set("email")} required className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="contact-email" /></div>
          <div><label className="block text-sm font-medium mb-1">{t("contact.phone")}</label><input value={form.phone} onChange={set("phone")} className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="contact-phone" /></div>
          <div><label className="block text-sm font-medium mb-1">{t("contact.message")} *</label><textarea value={form.message} onChange={set("message")} required rows={5} className="w-full border border-gray-300 px-4 py-3 outline-none focus:border-brand-red" data-testid="contact-message" /></div>
          <button type="submit" className="w-full bg-brand-red text-white font-semibold py-4 hover:bg-[#b81c14] transition-colors" data-testid="contact-submit">{t("contact.send")}</button>
          {sent && <p className="text-green-600 text-sm text-center">{t("contact.sent")}</p>}
        </form>
      </div>
    </div>
  );
}
